import { axiosInstance } from "@/lib/axios";
import queryClient from "@/lib/queryClient";
import { ContactUsType } from "@/schemas/contact-us-schema";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";

export async function createContactUsMessage(data: ContactUsType) {
    return (await axiosInstance.post("/api/contact-us", data)).data;
}


type ContactUsQuery = (ContactUsType & { id: string, createdAt: string })[]
export async function getContactUsMessages() {
    return (await axiosInstance.get<ContactUsQuery>("/api/contact-us")).data;
}

export const ContactUs = {
    Get: {
        useQuery: (options = {}) => {
            return useQuery({
                queryKey: ["contact-us"],
                queryFn: getContactUsMessages,
                ...options,
            });
        },
    },
    Create: {
        useMutation: (options = {}) => {
            return useMutation({
              mutationFn: createContactUsMessage,

              onSuccess: () => {
                toast.success("Your message has been sent successfully!");
                queryClient.invalidateQueries({ queryKey: ["contact-us"] });
              },
              onError: (error: Error) => {
                toast.error("Failed to send message. Please try again.");
                console.error("Contact form submission error:", error);
              },
              ...options,
            });
        },
    },
};
